import { Grid, Tooltip, Typography } from '@mui/material';
import {
  noFileUploaded,
  OwnerDocuments,
  SiteReviewTitle,
  TextAsLink,
  uploadedFilesGrid,
} from '../../styles';
import { t } from 'i18next';

function UploadedFiles(props) {
  return (
    <Grid style={SiteReviewTitle}>
      <Grid style={uploadedFilesGrid}>
        <Grid style={OwnerDocuments}>{`${t(props.title)}:`}</Grid>
        <Grid style={OwnerDocuments}>
          {props.docs.length > 0 ? (
            props.docs.map((document, index) => {
              return (
                <Tooltip
                  key={index}
                  title={document}
                  componentsProps={{
                    tooltip: {
                      sx: {
                        fontSize: '14px',
                      },
                    },
                  }}
                >
                  <Typography
                    key={index}
                    noWrap
                    width={400}
                    style={TextAsLink}
                    onClick={() =>
                      props.downloadFunction({
                        ...props.payload,
                        filename: document,
                      })
                    }
                  >
                    {document}
                  </Typography>
                </Tooltip>
              );
            })
          ) : (
            <Grid style={noFileUploaded}>
              {t('No_files_have_been_uploaded')}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default UploadedFiles;
